export const getTextWidth = (
  text,
  font = "12px interregular",
  weight = "400"
) => {
  const context = document.createElement("canvas").getContext("2d");
  context.font = `${weight} ${font}`;
  return context.measureText(text).width;
};

export const DEFAULT_CONFIG = {
  padding: 8,
  columnGap: 6,
  rowGap: 4,
  itemHeight: 18,
  fontSize: "12px interregular",
  fontWeight: "400",
};

export const getVisibleItems = (
  items,
  parentWidth,
  parentHeight,
  config = DEFAULT_CONFIG
) => {
  if (items.length === 0) {
    return 0;
  }
  if (items.length === 1) {
    return 1;
  }

  const maxRows =
    config.maxRows ??
    Math.floor(
      (parentHeight + config.rowGap) / (config.itemHeight + config.rowGap)
    );

  if (maxRows <= 0) {
    return 1;
  }

  let currentRow = 0;
  let currentRowWidth = 0;
  let visibleItems = 0;
  const moreTextWidth =
    getTextWidth("+xx more", config.fontSize, config.fontWeight) +
    config.columnGap +
    config.padding;

  for (const item of items) {
    const itemWidth =
      getTextWidth(item, config.fontSize, config.fontWeight) +
      config.columnGap +
      config.padding;

    // Check if item fits in current row
    if (currentRowWidth + itemWidth <= parentWidth || visibleItems === 0) {
      currentRowWidth += itemWidth;
      visibleItems++;
    } else {
      // Move to next row
      currentRow++;

      // Check if we have room for another row
      if (currentRow >= maxRows) {
        // Check if we need to reserve space for "+X more"
        // Go back and see if "+X more" fits in the last row
        const lastRowWidth = currentRowWidth;

        // If "+X more" doesn't fit in current position, remove last item
        if (lastRowWidth + moreTextWidth > parentWidth && visibleItems > 1) {
          visibleItems--;
        }

        break;
      }

      // Start new row with current item
      currentRowWidth = itemWidth;
      visibleItems++;
    }
  }

  return Math.max(1, visibleItems);
};
